import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const NotFoundPage = () => {
    return (
        <section className="min-h-[70vh] flex items-center justify-center px-4 lg:px-8">
            <div className="text-center max-w-xl">
                <p className="text-sm uppercase tracking-widest text-muted-foreground mb-3">404</p>
                <h1 className="font-display text-4xl lg:text-5xl text-foreground mb-4">
                    Page not found
                </h1>
                <p className="text-muted-foreground mb-8">
                    The page you are looking for does not exist or has been moved.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <Link to="/">
                        <Button className="btn-accent rounded-lg px-6">
                            Back to Home
                        </Button>
                    </Link>
                    <Link to="/contact#quote">
                        <Button variant="outline" className="rounded-lg px-6">
                            Get a Quote
                        </Button>
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default NotFoundPage;
